<script>
import {downloadInv} from "@/api/subscriptions";


export default {
  name: "SubscriptionDownloadInvoice",
  data() {
    if (this.$route.params.id) {
      this.load(this.$route.params.id)
    }
    return {
      invoiceCreated: false
    }
  },
  methods: {
    async load(id) {
      downloadInv(id).then((response) => {
        this.invoiceCreated = true
        const url = window.URL.createObjectURL(new Blob([response.data], {
          type:
              'application/pdf'
        }));
        const link = document.createElement('a');
        link.href = url;
        link.setAttribute('download', 'invoice.pdf');
        document.body.appendChild(link);
        link.click();
      }).catch(() => {
        alert('Произошла ошибка, возможно счет уже не актуален.')
      })
    }
  }
}
</script>

<template>
  <div class="ais24--subscription">
    <div class="ais24--container">
      <div class="ais24--steps">
        <ul class="ais24--steps__list">
          <li class="ais24--steps__item">Подписка на сервисы</li>
          <li class="ais24--steps__item">Детали подписки</li>
          <li class="ais24--steps__item active">Оплата</li>
        </ul>
      </div>
      <header class="ais24--header">
        <h2 class="ais24--title">Успешно</h2>
      </header>
      <div class="ais24--ready-invoice">
        <div class="ais24--ready-invoice__icon">
          <svg class="ais24--icon ais24--icon--44x44">
            <use xlink:href="/img/sprite.svg#icon-44-check-circle"></use>
          </svg>
        </div>
        <div class="ais24--ready-invoice__headline">
          <h3 class="ais24--ready-invoice__title">Ваш счёт успешно создан!</h3>
          <div class="ais24--ready-invoice__caption">
            <p>Загрузка должна начаться автоматически.
              <br>Если загрузка не началась, то можете
              <router-link :to="{'name': 'SubscriptionInvoicePage'}">скачать счёт тут</router-link>
              .
            </p>
          </div>
        </div>
        <div class="ais24--ready-invoice__content">
          <div class="ais24--ready-invoice__text">
            <p>Также все выставленные счета хранятся
              <br>в&nbsp;разделе &laquo;Мои счета&raquo;
            </p>
            <p>
              <router-link :to="{'name': 'SubscriptionInvoicePage'}"
                           class="ais24--button ais24--button--default ais24--button--small">
                <span class="ais24--button__text">Мои счета</span>
              </router-link>
            </p>
          </div>
        </div>
        <div class="ais24--ready-invoice__info">
          <div class="ais24--alert ais24--alert--warning">
            <div class="ais24--alert__icon">
              <svg class="ais24--icon ais24--icon--24x24">
                <use xlink:href="/img/sprite.svg#icon-24-info-circle"></use>
              </svg>
            </div>
            <div class="ais24--alert__text">
              <p>Обращаем ваше внимание, что счёт доступен для оплаты в&nbsp;течение 3-х рабочих дней.</p>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<style scoped lang="scss">

</style>
